import { Switch, Route, Redirect } from "wouter";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Assessment from "@/pages/Assessment";
import AssessmentResults from "@/pages/AssessmentResults";
import AssessmentDetailedResults from "@/pages/AssessmentDetailedResults";
import AssessmentDisclosure from "@/pages/AssessmentDisclosure";
import AssessmentMethodology from "@/pages/AssessmentMethodology";
import ReportPrint from "@/pages/ReportPrint";
import Settings from "@/pages/Settings";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminCompanyDetail from "@/pages/admin/AdminCompanyDetail";
import AdminStats from "@/pages/admin/AdminStats";
import AdminProfile from "@/pages/admin/AdminProfile";
import { Shell } from "@/components/layout/Shell";
import { AdminShell } from "@/components/layout/AdminShell";
import { AuthGate } from "@/components/layout/AuthGate";
import { useAuthContext } from "@/context/AuthContext";

function RoleRouter() {
  const { user } = useAuthContext();

  if (user.role === "platform_admin") {
    return (
      <AdminShell>
        <Switch>
          <Route path="/admin/users" component={AdminUsers} />
          <Route path="/admin/companies/:id" component={AdminCompanyDetail} />
          <Route path="/admin/companies" component={AdminCompanies} />
          <Route path="/admin/stats" component={AdminStats} />
          <Route path="/admin/profile" component={AdminProfile} />
          <Route>
            <Redirect to="/admin/users" />
          </Route>
        </Switch>
      </AdminShell>
    );
  }

  return (
    <Shell>
      <Switch>
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/assessment" component={Assessment} />
        <Route path="/assessment/results" component={AssessmentResults} />
        <Route path="/assessment/detailed" component={AssessmentDetailedResults} />
        <Route path="/assessment/disclosure" component={AssessmentDisclosure} />
        <Route path="/assessment/methodology" component={AssessmentMethodology} />
        <Route path="/settings" component={Settings} />
        <Route>
          <Redirect to="/dashboard" />
        </Route>
      </Switch>
    </Shell>
  );
}

function App() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/signup" component={Signup} />
      <Route path="/terms" component={Terms} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/reset-password" component={ResetPassword} />
      {/* Rendered only by headless Chromium for the Tab 4 PDF export. Deliberately outside AuthGate/Shell:
          it handles its own auth failure so the server gets a fast error instead of a /login redirect. */}
      <Route path="/report-print" component={ReportPrint} />
      {/* Unconditional — runs before AuthGate resolves the role. A platform_admin
          hitting "/" bounces through /dashboard, then RoleRouter redirects to
          /admin/users; a harmless extra hop, not a security gap. */}
      <Route path="/">
        <Redirect to="/dashboard" />
      </Route>
      <Route>
        <AuthGate>
          <RoleRouter />
        </AuthGate>
      </Route>
    </Switch>
  );
}

export default App;
